import ModalRouting from "./ModalRouting";

export default ModalRouting;
